import { z } from 'zod';
import { amountSchema } from './units';

const accountReferenceSchema = z.string();
type AccountReference = z.infer<typeof accountReferenceSchema>;

const basAccountSchema = z.number();

const accountInfoSchema = z.object({
  account: accountReferenceSchema,
  accountName: z.string(),
  basAccount: basAccountSchema,
  openingBalance: amountSchema,
  closingBalance: amountSchema,
  computedBalance: amountSchema,
  previousYearClosingBalance: amountSchema.optional(),
  numDebit: z.number(),
  totalDebit: amountSchema,
  numCredit: z.number(),
  totalCredit: amountSchema,
});
type AccountInfo = z.infer<typeof accountInfoSchema>;

const accountMapSchema = z.map(accountReferenceSchema, accountInfoSchema);

export {
  accountInfoSchema,
  accountMapSchema,
  accountReferenceSchema,
  basAccountSchema,
  type AccountInfo,
  type AccountReference,
};
